<template>
  <div :class="$style.component">
    <div :class="$style.wrapper">
      <transition name="t-bio" mode="out-in">
        <div v-if="!bioVisible" :class="$style.row" key="details">
          <span v-if="image.artist.title" v-html="image.artist.title" />
          <span v-if="image.title" v-html="image.title" :class="$style.title" />
          <span v-if="publicationYear" v-html="publicationYear" />
        </div>
        <div v-else v-html="image.artist.title" key="title" />
      </transition>
      <transition name="t-bio" mode="out-in">
        <div v-if="!bioVisible" :class="$style.row" key="details">
          <span v-if="image.execution" v-html="image.execution" />
          <span v-if="image.dimensions" v-html="image.dimensions" />
        </div>
        <div v-else v-html="subtitle" key="title" />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    image: {
      type: Object,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(['bioVisible']),
    publicationYear() {
      return this.image.publication_year_freetext
        ? this.image.publication_year_freetext
        : this.image.publication_year
    }
  }
}
</script>

<style lang="scss" scoped>
.t-bio-enter-active,
.t-bio-leave-active {
  transition: opacity var(--medium) ease;
}

.t-bio-leave-active {
  transition-delay: var(--xshort);
}

.t-bio-enter,
.t-bio-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" module>
.component {
  text-align: center;
}

.wrapper {
  overflow-y: auto;
}

.row {
  @extend %fs-slide-description;

  > :not(:last-child) {
    &:after {
      content: ',';
      padding-right: 0.25em;
    }
  }
}

.title {
  @extend %ff-italic;
}
</style>
